import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ReferralModel extends BaseModel {
  static urlPath = "referrals";

  @attr("string") createdAt;
  @attr("json") createdBy;
  @attr("string") updatedAt;
  @attr("json") updatedBy;
  @belongsTo("provider") referralFrom;
  @belongsTo("provider") referralTo;
  @attr("string") client;
  @attr("string") referredAt;
  @attr("string") source;
  @attr("string") status;
  @attr("json") providerType;
}
